import { CONTACT_US_INFO_TYPE } from 'features/order-tracker/utils/entries/contactUsInfoType';

// eslint-disable-next-line no-unused-vars
import { AppointmentStrategy } from './AppointmentStrategy';

export class AmendedAppointmentStrategy implements AppointmentStrategy {
  getInfoType = (): common.ContactUsInfo => CONTACT_US_INFO_TYPE.AlreadyAmended;

  isReminderAvailable = (): boolean => false;

  isSiteContactAvailable = (appointment: common.EngineerAppointment): boolean => !!appointment.siteContact;

  isAmendable = (): boolean => false;

  isApplicable = (_appointment: common.EngineerAppointment, amendedInfo: common.AmendsInfo[]): boolean => !!amendedInfo;

  isHelpSectionAvailable = (): boolean => false;
}
